// extracted by mini-css-extract-plugin
export default {"layout-search-bar":"LayoutSearchBar_layout-search-bar__+BskJ","layoutSearchBar":"LayoutSearchBar_layout-search-bar__+BskJ"};